import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change, reset } from 'redux-form'
import Calendar from 'react-calendar';
import Moment from 'react-moment'
import { 
  Icon,
  Input,
  Form,
  Dropdown,
  Button } from  'semantic-ui-react'
import {
  Collapse } from '@material-ui/core';

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { 
  fetchProjects,
  getCompanies,
  getVendors
} from 'ducks/options'
import { 
  SearchCont,
  InputCont,
  AdvanceCont,
  DateCont } from './styled'
  
const SearchList = (props) => {
  const {
    projects,
    valueForm,
    dispatch,
    companies,
    vendors,
    customer,
    //props
    pageSize,
    formSearchName,
    fetchAPI,
    placeholder='',
    filterDate=false,
    filterStatus=false,
    filterStatusOptions=null,
    filterCompany=false,
    filterVendor=false,
    filterCustomer=false,
    filterPurchasingOrgOption=null,
    filterPurchasingOrg=false,
    hideProject=false,
    multiCompany=false,
    useLocalCompanyCode=false
  } = props

  const [visibleAS,setVisibleAS] = React.useState(false)
  const [visibleSelectDate,setVisibleSelectDate] = React.useState(false)
  const [date,setDate] = React.useState([null,null])

  React.useEffect(() => {
    if(!hideProject) props.fetchProjects()
    if(filterCompany) props.getCompanies()
    if(filterVendor) props.getVendors()
    change(formSearchName,'dateType','-')
    change(formSearchName,'projectId',0)
    let searchCompanyCode = localStorage.getItem('searchCompanyCode')
    if(searchCompanyCode=='undefined') searchCompanyCode='[]'
    change(formSearchName,'companyCode',multiCompany?JSON.parse(searchCompanyCode):0)
    if(useLocalCompanyCode){
      change(formSearchName,'companyCode',Number(localStorage.getItem('filterCompanyCode')) || 0)
    }
    change(formSearchName,'status','-')
    change(formSearchName,'key','')
    change(formSearchName,'page',1)
    change(formSearchName,'size',10)
  },[])

  React.useEffect(() => {
    change(formSearchName,'dateStart',date[0]?new Date(date[0]).toJSON():'')
    change(formSearchName,'dateEnd',date[1]?new Date(date[1]).toJSON():'')
  },[date])

  React.useEffect(() => {
    if(valueForm){
      if(multiCompany){
        localStorage.setItem('searchCompanyCode',JSON.stringify(valueForm.companyCode))
      }
    }
  },[valueForm&&valueForm.companyCode])

  React.useEffect(() => {
    if(valueForm&&valueForm.dateStart&&valueForm.dateEnd){
      fetchAPI({...props.valueForm})
    }
  },[valueForm&&valueForm.dateStart,valueForm&&valueForm.dateEnd])

  function setProjects(){
    if(projects.data){
      return projects.data.sort((a, b) => a.text?a.text.localeCompare(b.text):-1)
    }
    return []
  }

  function setCompanies(){
    if(companies.data){
      return companies.data.sort((a, b) => a.text?a.text.localeCompare(b.text):-1)
    }
    return []
  }

  function onResetClick(){
    setDate([null,null])
    change(formSearchName,'dateType','-')
    change(formSearchName,'status','-')
    change(formSearchName,'projectId',0)
    change(formSearchName,'companyCode',0)
    change(formSearchName,'key','')
    fetchAPI({page:1,size:pageSize})
  }

  function onAdvanceSearchClick(data){
    let c = ''
    if(valueForm.companyCode&&Array.isArray(valueForm.companyCode)){ //case select multi CompanyCode
      valueForm.companyCode.forEach(i => {
        c += ','+i
      })
      c = c.substring(1)
    }else{
      c = valueForm.companyCode
    }
    fetchAPI({...props.valueForm, companyCode:c, ...data, page:1,size:pageSize})
  }

  return (
    <SearchCont>
      <InputCont>
        <Field name="key" placeholder={placeholder} onSearchClick={()=>onAdvanceSearchClick()} component={renderInputSearch} onEnter={()=>onAdvanceSearchClick()}/> 
        <Icon name='settings' circular inverted link onClick={()=>setVisibleAS(!visibleAS)}/>
      </InputCont>
      <Collapse in={visibleAS} timeout="auto" unmountOnExit>
        <AdvanceCont>
          
          {filterDate&&
          <React.Fragment>
            <Field
              name="dateType"
              label="Date Range Type"
              allowAdditions={false}
              options={[
                {value:'-',text:'All Date Range'},
                {value:'SubmittedOn',text:'Submitted Date'},
                {value:'ModifiedOn',text:'Modified Date'}
              ]}
              specialOnChange={(value) => {
                setVisibleSelectDate(true)
              }}
              type={type.select}
              component={FieldInput}
            />
            <div style={{display:'flex',flexDirection:'column',marginTop:'1.27rem'}}>
              <DateCont>
                <Moment format="DD MMM YYYY">{date[0]||Date.now()}</Moment>
                {`  -  `}
                <Moment format="DD MMM YYYY">{date[1]||Date.now()}</Moment>
              </DateCont>
              <Collapse in={visibleSelectDate} timeout="auto" unmountOnExit>
                <div style={{marginTop:'0.5rem'}}>
                  <Calendar
                    onChange={(date)=>{
                      setDate(date)
                      setVisibleSelectDate(false)
                      onAdvanceSearchClick(null)
                    }}
                    value={date}
                    selectRange={true}
                  />
                </div>
              </Collapse>
            </div>
            <Icon style={{marginTop:'1.7rem'}} name='calendar alternate outline' circular inverted link onClick={()=>setVisibleSelectDate(!visibleSelectDate)}/>
          </React.Fragment>}

          {filterStatus&&
          <Field
            name='status'
            label='Status'
            placeHolder='All Status'
            allowAdditions={false}
            options={filterStatusOptions?filterStatusOptions:[
              { key: 1,value: '-', text: 'All Status' },
              { key: 2,value: '0', text: 'Draft' },
              { key: 3,value: '1', text: 'New' },
              { key: 4,value: '2', text: 'In Progress' },
              { key: 5,value: '3', text: 'Revise' },
              { key: 6,value: '4', text: 'Completed' },
              { key: 7,value: '5', text: 'Reject' },
              { key: 8,value: '6', text: 'Cancelled' },
            ]}
            specialOnChange={(value) => {
              onAdvanceSearchClick({ status: value })
            }}
            type={type.select}
            component={FieldInput}
          />}
          {filterPurchasingOrg&&
          <Field
            name='purchasingOrg'
            label='PurchasingOrg'
            allowAdditions={false}
            options={[{ key: 1,value: '-', text: 'All Purchasing Org' },...filterPurchasingOrgOption]}
            specialOnChange={(value) => {
              onAdvanceSearchClick({ purchasingOrg: value })
            }}
            type={type.select}
            component={FieldInput}
          />}
          {
            hideProject ? null :
            <Field
              name="projectId"
              label="Project"
              placeHolder='All Project'
              allowAdditions={false}
              loading={projects.loading}
              options={
                [
                  {key:'a', value:0,text:'All Project'},
                  ...setProjects()
                ]
              }
              specialOnChange={(value) => {
                onAdvanceSearchClick({projectId:value})
              }}
              type={type.select}
              component={FieldInput}
            />
          }
          {filterCompany&&!multiCompany&&
          <Field
            name="companyCode"
            label="Company"
            placeHolder='All Company'
            allowAdditions={false}
            loading={companies.loading}
            options={
              [
                {key:'a',value:0,text:'All Company'},
                ...setCompanies()
              ]
            }
            useLazyLoad
            specialOnChange={(value) => {
              localStorage.setItem('filterCompanyCode', Number(value))
              onAdvanceSearchClick({companyCode:value})
            }}
            type={type.select}
            component={FieldInput}
          />}
          {filterVendor&&
            <Field
              name='vendorCode'
              label='Vendor'
              allowAdditions={false}
              loading={vendors.loading}
              options={[
                {key:0,value:0,text:'-'},
                ...vendors.data
              ]} 
              type={type.select}
              placeHolder={'All Vendor'}
              editable
              component={FieldInput}
              useLazyLoad
              specialOnChange={(value) => {
                localStorage.setItem('filterVendorCode', Number(value))
                onAdvanceSearchClick({vendorCode:value})
              }}
            />
          }
          {filterCustomer&&
            <Field
              name='customerCode'
              label='Customer'
              allowAdditions={false}
              loading={customer.loading}
              options={[
                {key:0,value:0,text:'-'},
                ...customer.data
              ]} 
              type={type.select}
              placeHolder={'All Customer'}
              editable
              component={FieldInput}
              useLazyLoad
              specialOnChange={(value) => {
                localStorage.setItem('filterCustomerCode', value)
                onAdvanceSearchClick({customerCode:value})
              }}
            />
          }
          <Button type='button' style={{marginLeft:'1rem',marginTop:'1.37rem'}} onClick={()=>{reset(props.formSearchName);onResetClick()}}>Clear</Button>
        </AdvanceCont>
        <div style={{display:'flex'}}>
          {filterCompany&&multiCompany&&
          <Field
            name="companyCode"
            label="Company"
            placeHolder='All Company'
            allowAdditions={false}
            loading={companies.loading}
            options={
              [
                ...setCompanies()
              ]
            }
            specialOnChange={(value) => {
              let c = ''
              value.forEach(i => {
                c += ','+i
              })
              c = c.substring(1)
              onAdvanceSearchClick({companyCode:c})
            }}
            type={type.multiSelect}
            component={FieldInput}
          />}
          <div style={{flex:1}}/>
        </div>
      </Collapse>
    </SearchCont>
  )

}

const renderInputSearch = props => {
  const {input,onSearchClick,placeholder} = props
  return (
    <Input 
    {...input}
    onKeyDown={(e)=>{
      if (e.key === 'Enter') {
        props.onEnter()
      }
    }}
    className='searchInput' 
    icon={<Icon type='button' name='search' inverted circular link onClick={onSearchClick}/>} 
    placeholder={placeholder} />
  )
}

const mapStateToProps = (state,props) => {
  return ({
    valueForm: getFormValues(props.formSearchName)(state)||{},
    companies: state.options.companies,
    projects: state.options.projects,
    vendors: state.options.vendors,
    customer: state.options.customers,
  })
}

const mapDispatchToProps = {
  change,
  fetchProjects,
  getCompanies,
  getVendors
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchList)
